// src/apis/index.js（按你实际路径调整）
import axios from 'axios'
import { Message } from 'element-ui'
import { getI18n } from '@/i18n'

let config = window.CONFIG_JSON || {}

const instance = axios.create({
  baseURL: config['baseUrl'],
  timeout: 1000 * 30
})

// 动态取 i18n 实例：模块加载时可能还没 createI18n，请求发出时一定有
function t(key, ...args) {
  const i18n = getI18n()
  if (!i18n) return key
  return i18n.t(key, ...args)
}

// 取当前 locale
function currentLocale() {
  const i18n = getI18n()
  return i18n ? i18n.locale : 'en'
}

// ===== 服务端消息翻译（兜底）=====
function translateServerMsg(msg) {
  if (!msg) return ''

  const i18n = getI18n()
  if (!i18n) return msg

  // 1. 若后端直接返回 i18n key（如 "common.msg.unauthorized"），直接翻译
  if (typeof msg === 'string' && msg.indexOf('common.') === 0) {
    const translated = i18n.t(msg)
    if (translated && translated !== msg) return translated
  }

  // 2. 用 serverMsg 字典映射（语言包里维护中文->英文）
  const messages = i18n.getLocaleMessage(i18n.locale) || {}
  const dict = messages.common && messages.common.serverMsg
  if (dict && typeof dict === 'object' && dict[msg]) {
    return dict[msg]
  }

  // 3. 非中文环境且消息含中文，返回通用错误
  if (i18n.locale !== 'zh' && /[\u4e00-\u9fa5]/.test(msg)) {
    return i18n.t('common.msg.serverError')
  }
  return msg
}

// ===== 请求拦截器 =====
instance.interceptors.request.use(
  (req) => {
    req.headers['Cache-Control'] = 'no-cache,no-store'
    req.headers['Pragma'] = 'no-cache'
    req.headers['Accept-Language'] = currentLocale() === 'zh' ? 'zh-CN' : 'en-US'
    return req
  },
  (error) => Promise.reject(error)
)

// ===== 响应拦截器 =====
instance.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      const isBinary = res.config && (res.config.responseType === 'blob' || res.config.responseType === 'arraybuffer')
      if (!isBinary && res.data && typeof res.data === 'object' && 'success' in res.data && !res.data.success) {
        // Message.error(...)
      }
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  },
  (error) => {
    // 二进制请求（导出等）错误交给调用方处理，避免与页面层提示重复
    const isBinary = error.config && (error.config.responseType === 'blob' || error.config.responseType === 'arraybuffer')
    if (isBinary) {
      return Promise.reject(error)
    }

    const status = error.response && error.response.status
    let msg = ''
    switch (status) {
      case 401: msg = t('common.msg.unauthorized'); break
      case 403: msg = t('common.msg.forbidden'); break
      case 404: msg = t('common.msg.notFound'); break
      case 500:
      case 502:
      case 503: msg = t('common.msg.serverError'); break
      default: msg = t('common.msg.networkError')
    }
    if (!msg || typeof msg !== 'string' || msg.indexOf('common.') === 0) {
      msg = 'Network error, please try again later.'
    }
    Message.error(msg)
    return Promise.reject(error)
  }
)

/**
 * 使用 es6 的 export default 导出了一个函数，导出的函数代替 axios 去帮我们请求数据
 * @param {string} method - 请求方法
 * @param {string} url - 请求路径
 * @param {object} data - 请求参数
 * @param {object} config - axios 额外配置（如 responseType: 'blob'）
 */
export default function (method, url, data = null, config = {}) {
  method = method.toLowerCase()
  if (method === 'post') {
    return instance.post(url, data, config)
  } else if (method === 'get') {
    return instance.get(url, { params: data, ...config })
  } else if (method === 'delete') {
    return instance.delete(url, { params: data, ...config })
  } else if (method === 'put') {
    return instance.put(url, data, config)
  } else {
    console.error('未知的method：' + method)
    return false
  }
}



// WEBPACK FOOTER //
// ./src/apis/index.js